import {
  ClearIndicator,
  Control,
  DropdownIndicator,
  IndicatorSeparator,
  Input,
  Menu,
  MultiValueRemove,
} from "../react_select_components";
import { components, SelectComponentsConfig, ValueContainerProps } from "react-select";
import type { Grouped, Option } from "../types";
import React, { useMemo } from "react";

const DEFAULT_MAPPING: SelectComponentsConfig<Option, boolean, Grouped<Option>> = {
  ClearIndicator,
  Control,
  DropdownIndicator,
  IndicatorSeparator,
  Input,
  Menu,
  MultiValueRemove,
};

export const useValueContainer = (startIcon: React.ReactNode) => {
  return useMemo(() => {
    const ValueContainer = ({
      children,
      ...props
    }: ValueContainerProps<Option, boolean, Grouped<Option>>): React.ReactNode => {
      const showIcon = !!children && !!startIcon;

      return (
        components.ValueContainer && (
          <components.ValueContainer {...props}>
            {showIcon && <span style={{ position: "absolute", left: 0 }}>{startIcon}</span>}
            {children}
          </components.ValueContainer>
        )
      );
    };

    ValueContainer.displayName = "StartIconValueContainer";

    return ValueContainer;
  }, [startIcon]);
};

export const useCustomReactSelectComponents = (
  overrides?: SelectComponentsConfig<Option, boolean, Grouped<Option>>,
): SelectComponentsConfig<Option, boolean, Grouped<Option>> => {
  return useMemo(
    () => ({
      ...DEFAULT_MAPPING,
      ...overrides,
    }),
    [overrides],
  );
};
